import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getGroundVsAir,
    getOptimizedGroundVsAir,
    getGroundVsAirDetails,
    getOptimizedGroundVsAirDetails,
} from '../../helpers';
import {
    operationalOptimizationsApiResponseSuccess,
    operationalOptimizationsApiResponseError,
} from './actions';
import { OperationalOptimizationsActionTypes } from './constants';

export function* getGroundVsAirSaga({ payload: { query } }) {
    try {
        const response = yield call(getGroundVsAir, query);
        yield put(operationalOptimizationsApiResponseSuccess(OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR, response.data));
    } catch (error) {
        yield put(operationalOptimizationsApiResponseError(OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR, error));
    }
}

export function* getOptimizedGroundVsAirSaga({ payload: { query } }) {
    try {
        const response = yield call(getOptimizedGroundVsAir, query);
        yield put(operationalOptimizationsApiResponseSuccess(OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR, response.data));
    } catch (error) {
        yield put(operationalOptimizationsApiResponseError(OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR, error));
    }
}

export function* getGroundVsAirDetailsSaga({ payload: { query } }) {
    try {
        const response = yield call(getGroundVsAirDetails, query);
        yield put(operationalOptimizationsApiResponseSuccess(OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR_DETAILS, response.data));
    } catch (error) {
        yield put(operationalOptimizationsApiResponseError(OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR_DETAILS, error));
    }
}

export function* getOptimizedGroundVsAirDetailsSaga({ payload: { query } }) {
    try {
        const response = yield call(getOptimizedGroundVsAirDetails, query);
        yield put(operationalOptimizationsApiResponseSuccess(OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR_DETAILS, response.data));
    } catch (error) {
        yield put(operationalOptimizationsApiResponseError(OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR_DETAILS, error));
    }
}

export function* watchGetGroundVsAirSaga() {
    yield takeLatest(OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR, getGroundVsAirSaga);
}

export function* watchGetOptimizedGroundVsAirSaga() {
    yield takeLatest(OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR, getOptimizedGroundVsAirSaga);
}

export function* watchGetGroundVsAirDetailsSaga() {
    yield takeLatest(OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR_DETAILS, getGroundVsAirDetailsSaga);
}

export function* watchGetOptimizedGroundVsAirDetailsSaga() {
    yield takeLatest(OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR_DETAILS, getOptimizedGroundVsAirDetailsSaga);
}

function* operationalOptimizationsSaga() {
    yield all([
        fork(watchGetGroundVsAirSaga),
        fork(watchGetOptimizedGroundVsAirSaga),
        fork(watchGetGroundVsAirDetailsSaga),
        fork(watchGetOptimizedGroundVsAirDetailsSaga),
    ]);
}

export default operationalOptimizationsSaga;
